    import { types } from "./edi.actions";
    import { Reducer } from "../../services/reducer.factory";
    
    const initialState = {
      columns: [{
        field: "oid",
        header: "Código",
        columnKey: "oid",
        sortable: "false",
        filter: "false"
      },{
        field: "name",
        header: "Nome",
        columnKey: "name",
        sortable: "false",
        filter: "false"
      }],
      currentRecord: {oid:"",name:""},
      
    };
    
    const reducer = new Reducer(initialState, types);
    
    export function CRUDEdiReducer(state, action) {
      state = reducer.execute(state, action);
      return execute(state,action);
    }
    
    function execute(state, action){
        let result = state;
        switch(action.type){
          
          
        }
        return result;
    }
   
    
    
    